module.exports = __webpack_public_path__ + "img/moneyBg.658e554f.png";